<template lang="html">
  <div class="product-intro">
    <!-- banner -->
    <div
      class="poster"
      v-if="product.cmmdtyImages && product.cmmdtyImages.length > 0"
    >
      <swipe ref="swipe" :show-indicators="false" @change="handleChange">
        <swipe-item
          v-if="
            product.cmmdtyVideo &&
            product.cmmdtyVideo !== '' &&
            mainConfig.videoPosition === 'top'
          "
        >
          <div class="player">
            <videoPanel
              :track="{
                pageId: '100101',
                eventType: '20000',
                eventId: '21241'
              }"
              :src="product.cmmdtyVideo"
              :canPlay="canPlay"
              @showVideo="playingStatus"
              :poster="coverImg"
              v-on:x5FullScreen="videoStatus"
            ></videoPanel>
          </div>
        </swipe-item>
        <swipe-item
          v-for="(item, index) in product.cmmdtyImages"
          :key="index"
          v-if="showSwipe"
        >
          <img
            v-lazy="$$viewImage(item, 750, 422, undefined, 2)"
            @click="showImage(product.cmmdtyImages, index)"
          />
        </swipe-item>
      </swipe>
      <imagePreview
        :items="previewImages"
        :isPreview="isPreviewPhotos"
        :index="previewPhontoIndex"
        @close="closePreviewPhotos"
      >
      </imagePreview>
      <div
        v-if="showMediumType && (!showVideo || indexSwipe > 1)"
        class="medium-type"
        @click="clickType"
      >
        {{ mediumText }}
      </div>
      <div
        class="swipe-index"
        v-if="(!showVideo || indexSwipe > 1) && tipSwipe(indexSwipe).length > 0"
      >
        <span class="index pf-medium">{{ indexSwipe }}</span
        >/<span class="img-count">{{ imageCount }}</span>
      </div>
    </div>
    <!-- 秒杀标题+价格 ./seckill-tips -->
    <seckillTips v-if="mixInfo.isSeckill" :product="product"></seckillTips>
    <!-- 普通标题+价格 ./common-tips -->
    <commonTips v-else :product="product"></commonTips>
  </div>
</template>

<script>
import { mapState } from 'vuex'
// const {mapState} = createNamespacedHelpers('promotionInfo')

import { E_PROMOTION_TYPE, PROMOTION_TYPES } from '@/config'
import { Swipe, SwipeItem } from 'vant'
import videoPanel from '@/components/common/video'
// import promotionInfo from "./product-promotion";
import seckillTips from './seckill-tips'
import commonTips from './common-tips'
import mixProm from '@/mixin/mixProm'
import imagePreview from '@/components/common/viewImageNew'

export default {
  mixins: [mixProm],
  inject: {
    cmmdImgTrackParams: {
      default: null
    }
  },
  props: {
    product: {
      type: Object,
      default: () => {}
    },
    showPrice: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showVideo: false,
      mediumText: '图片',
      canPlay: true,
      showSwipe: true,
      indexSwipe: 1,
      hasParams: false,
      isPreviewPhotos: false,
      previewPhontoIndex: 0
    }
  },
  created() {},
  methods: {
    showImage(images, index) {
      // const query = this.$route.query
      this.$store.commit('setPreviewImages', images)
      // this.$router.push({ query: { ...query, preview: true, index } })
      this.isPreviewPhotos = true
      this.previewPhontoIndex = index
      this.cmmdImgTrackParams && this.$$newTrackClick(this.cmmdImgTrackParams)
    },
    closePreviewPhotos() {
      this.isPreviewPhotos = false
    },
    clickType() {
      if (this.mediumText === '图片') {
        this.$refs.swipe?.swipeTo(1)
      } else {
        this.$refs.swipe?.swipeTo(0)
      }
    },
    playingStatus(val) {
      this.showVideo = val
    },
    isAndroidsWX() {
      const u = window.navigator.userAgent
      const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
      const isWX = /micromessenger/i.test(u)
      return isAndroid && isWX
    },
    tipSwipe(index) {
      let numImg = this.product.cmmdtyImages && this.product.cmmdtyImages.length
      const hasVideo =
        this.product.cmmdtyVideo &&
        this.product.cmmdtyVideo !== '' &&
        this.mainConfig.videoPosition === 'top'
      let num = numImg + (true === hasVideo ? 1 : 0)

      if (num <= 1) {
        return ''
      }
      return index + '/' + num
    },
    handleChange(index) {
      this.indexSwipe = index + 1
      const hasVideo =
        this.product.cmmdtyVideo &&
        this.product.cmmdtyVideo !== '' &&
        this.mainConfig.videoPosition === 'top'
      if (this.showMediumType) {
        if (hasVideo && index > 0) {
          this.mediumText = '视频'
        } else {
          this.mediumText = '图片'
        }
      }
      if (!this.isAndroidsWX() && hasVideo) {
        if (index !== 0) {
          this.canPlay = false
        } else {
          this.canPlay = true
        }
      }
    },
    videoStatus(status) {
      if (this.isAndroidsWX()) {
        if (status) {
          this.showSwipe = false
        } else {
          this.showSwipe = true
        }
      }
    }
  },
  computed: {
    ...mapState(['previewImages']),
    ...mapState(['mainConfig']),
    ...mapState('promotionInfo', {
      promotionInfo: state => state.promotionInfo
    }),
    coverImg() {
      if (this.product.cmmdtyImages && this.product.cmmdtyImages.length > 0) {
        return this.product.cmmdtyImages[0]
      }
      return this.product.cmmdtyVideoCover || ''
    },
    showMediumType() {
      return this.product.cmmdtyVideo && this.mainConfig.videoPosition === 'top'
    },
    imageCount() {
      let numImg = this.product.cmmdtyImages && this.product.cmmdtyImages.length
      const hasVideo =
        this.product.cmmdtyVideo &&
        this.product.cmmdtyVideo !== '' &&
        this.mainConfig.videoPosition === 'top'
      let num = numImg + (true === hasVideo ? 1 : 0)
      return num
    }
  },
  components: {
    Swipe,
    SwipeItem,
    videoPanel,
    // promotionInfo,
    seckillTips,
    commonTips,
    imagePreview
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/mixin';

.product-intro {
  background: #fff;
  position: relative;
  .poster {
    position: relative;
    height: rem(422px);

    img {
      display: block;
      width: 100%;
      height: rem(422px);
      object-fit: cover;
    }
    /deep/.pic-swipe-inner img {
      width: 100%;
      object-fit: contain;
    }
  }
  .player {
    display: block;
    height: rem(422px);
    // background: #000;
    // display: flex;
    // align-items: center;
    //
    // video{
    //     max-width: 100%;
    //     max-height: 100%;
    // }
  }

  .medium-type {
    left: 0;
    right: 0;
    margin: 0 auto;
    bottom: rem(20px);
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    width: rem(92px);
    height: rem(44px);
    border-radius: rem(24px);
    border: 1px solid rgba(234, 234, 234, 1);
    box-sizing: border-box;
    background: rgba(255, 255, 255, 0.5);
    color: rgba(16, 16, 16, 1);
    font-size: rem(22px);
  }
  .swipe-index {
    height: rem(40px);
    display: flex;
    padding: 0 16px;
    align-items: center;
    justify-content: center;
    background: #000;
    opacity: 0.4;
    border-radius: rem(18px);
    color: #666666;
    font-size: rem(22px);
    position: absolute;
    right: rem(24px);
    bottom: rem(22px);
    z-index: 100;
    .index {
      font-size: rem(24px);
      color: #ffffff;
      font-weight: 500;
      margin-right: rem(4px);
    }
    .img-count {
      margin-left: rem(4px);
      font-size: rem(24px);
      opacity: 0.8;
      color: #ffffff;
    }
  }
  .product-price {
    display: flex;
    padding: rem(30px) rem(20px) rem(15px);
    align-items: center;

    .product-base {
      flex: 1;
      margin-right: rem(30px);
    }
    .name {
      font-size: rem(34px);
      font-weight: bold;
      word-break: break-all;
      text-align: left;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;
      display: -webkit-box;
      max-height: 2.4em;
      line-height: 1.25;
      // font-weight: 500;
      overflow: hidden;
      margin-bottom: rem(10px);
    }
    .sale-line {
      width: rem(1px);
      height: rem(58px);
      border: rem(1px) solid #ededed;
      margin-right: rem(36px);
    }
    .sale-num {
      font-size: rem(24px);
      text-align: center;
      color: #999;

      div:last-of-type {
        color: #121212;
        font-size: rem(36px);
        margin-top: rem(10px);
      }
    }
  }
}
</style>
<style lang="scss" module="skuMain">
@import '~@/assets/css/mixin';
.price {
  font-size: rem(36px);
  font-weight: 500;
  color: #ff397e;

  i {
    font-size: rem(24px);
    margin-right: rem(2px);
  }
}
del {
  color: #999;
  font-size: rem(30px);
  margin-left: rem(10px);
}
</style>
<style>
video::-webkit-media-controls {
  /*display:none*/
}
</style>
